module.exports = __webpack_public_path__ + "media/images/banners/bg2-2fd7063af31edce4ff92f2e68a49266c.png";